import * as TypeGraphQL from "type-graphql";
export var EventSeverity;
(function (EventSeverity) {
    EventSeverity["INFO"] = "INFO";
    EventSeverity["WARN"] = "WARN";
    EventSeverity["ERROR"] = "ERROR";
    EventSeverity["CRITICAL"] = "CRITICAL";
})(EventSeverity || (EventSeverity = {}));
TypeGraphQL.registerEnumType(EventSeverity, {
    name: "EventSeverity",
    description: undefined,
});
//# sourceMappingURL=EventSeverity.js.map